var FeatureFlagValues;
(function (FeatureFlagValues) {
    FeatureFlagValues["isInContextEditorEnabled"] = "isInContextEditorEnabled";
    FeatureFlagValues["isRewardDisabled"] = "isRewardDisabled";
    FeatureFlagValues["isRecognitionReactionsEnabled"] = "isRecognitionReactionsEnabled";
    FeatureFlagValues["isInsChatroomEnabled"] = "isInsChatroomEnabled";
    FeatureFlagValues["isCustomisationEnabled"] = "isCustomisationEnabled";
    FeatureFlagValues["isReportingV3Enabled"] = "isReportingV3Enabled";
})(FeatureFlagValues || (FeatureFlagValues = {}));
export default FeatureFlagValues;
